import { Controller } from '@hotwired/stimulus';
import { paint } from '../lib/dom';

export default class extends Controller {
  static targets = ['editor', 'header', 'statusLanguage', 'statusPath'];

  static values = { bundleName: String, files: Array };

  static classes = ['entryActive', 'entryIdle', 'iconActive', 'iconIdle'];

  connect() {
    this.selected = this.filesValue[0]?.path ?? null;

    this.#render();
  }

  editorReady() {
    this.opened = null;

    this.#render();
  }

  select(event) {
    this.selected = event.currentTarget.dataset.path;

    this.#render();
  }

  #render() {
    this.#renderRows();
    this.#renderHeaders();
    this.#renderStatus();
    this.#renderDiff();
  }

  #renderRows() {
    for (const row of this.element.querySelectorAll('[role="treeitem"][data-path]')) {
      const active = row.dataset.path === this.selected;

      paint(row, active, this.entryActiveClasses, this.entryIdleClasses);
      paint(row.querySelector(':scope > svg'), active, this.iconActiveClasses, this.iconIdleClasses);
    }
  }

  #renderHeaders() {
    for (const header of this.headerTargets) {
      header.hidden = header.dataset.path !== this.selected;
    }
  }

  #renderStatus() {
    const file = this.#file;

    this.statusPathTarget.textContent = file ? `${this.bundleNameValue}/${file.path}` : '';
    this.statusLanguageTarget.textContent = file?.language ?? '';
  }

  #renderDiff() {
    if (!this.#diff || this.selected === null || this.selected === this.opened) return;

    this.opened = this.selected;

    const file = this.#file;

    this.#diff.show(file.path, file.before, file.after, file.language);
  }

  get #file() {
    return this.filesValue.find((candidate) => candidate.path === this.selected);
  }

  get #diff() {
    return this.application.getControllerForElementAndIdentifier(this.editorTarget, 'monaco-diff');
  }
}
